import { FC } from 'react';
import { mildangFirebaseAnalytics } from '@ui/utils/SALogEvent/mildangFirebase';
import SharedResetPasswordDialog from '@ui/components/user/patterns/ResetPasswordDialog/ResetPasswordDialog';
import useErrorSnakbar from 'hooks/useErrorSnakbar';

interface IResetPasswordDialog {
  open: boolean;
  onClose?: () => void;
}

const ResetPasswordDialog: FC<IResetPasswordDialog> = ({ open, onClose }) => {
  const { enqueueApolloError } = useErrorSnakbar();

  return (
    <SharedResetPasswordDialog
      open={open}
      onClose={onClose}
      onSubmitError={(e) => enqueueApolloError(e as any)}
      onSubmitProp={(formData) => mildangFirebaseAnalytics.logEvent('findPw_btn', formData)}
    />
  );
};

export default ResetPasswordDialog;
